import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import { AboutHero, Facilities, Numbers, OurStory, Pillars, Values } from './components/Sections';

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <AboutHero />
        <OurStory />
        <Pillars />
        <Values />
        <Facilities />
        <Numbers />
      </main>
      <SiteFooter />
    </div>
  );
}